<template>
	<page-content-layout class="quotes" title="Quotes">
		<button-group-view slot="tools" :actions="_filter" v-model="filter" />
		<button-view slot="tools" :label="edit ? 'Gem': 'Tilpas'" @click="editClick" />
		<div class="layout">
			<date-picker-std-view v-model="date" class="date" :status="_monthStatus" @browse="updateMonthStatus" />
			<perfect-scrollbar class="tasks" name="task" tag="div" :style="{
				//gridRow: search == '' ? '6' : '2 / 7',
				transition: 'grid-row 250ms'
			}">
				<transition-group name="task" tag="div">
					<div v-for="(task, i) in _tasks" :key="task.id" :class="['task', 'move']" @mouseenter="$store.commit('hover', [task, 'right'])" @mouseleave="$store.commit('hover', [null, 'right'])">
						<div class="color" :style="{ backgroundColor: _types.hasOwnProperty(task.type) ? _types[task.type].color : 'yellow' }"></div>
						<div class="name">#{{ task.num }} {{ task.name == '' ? '-' : task.name }}</div>
						<div class="inst">
							<drag :payload="{ type: 'store', data: {
								store: store.desc,
								task: task
							} }" v-for="(store, i) in getInstruction(task, 'store')" :key="i">
								<div class="title">Til lager</div>
								<div class="address">{{ store.address }}</div>
								<div class="content">{{ store.desc }}</div>
							</drag>
							<div v-for="(extract, i) in getInstruction(task, 'extract')" :key="i">
								<div class="title">Fra lager</div>
								<div class="address">{{ extract.address }}</div>
								<div class="content">{{ extract.desc }}</div>
							</div>
							<div v-if="task.type == 'handling'">
								{{ task.remarks }}
							</div>
						</div>
					</div>	
					
					<spinner-view v-if="_tasks == null" />	
				</transition-group>
			</perfect-scrollbar>
			<new-table-view draggable="storage" v-show="openSpot" class="win" @onClose="onClose" :actions="[
				{
					name: 'onClose',
					icon: 'close'
				}
			]" :columns="[
				{
					label: 'Placering',
					name: 'name',
					template: {
						name: 'profile',
						params: {
							photo: {
								data: '/images/icon-boxes.jpg'
							},
							name: {
								name: 'name'
							},
							title: {
								name: 'remarks'
							}
						}
					}
				}
			]" :items="openSpot ? openSpot._embedded.storage : []" @itemClick="deleteStorage" />
			<new-table-view draggable="storage" v-show="openUnit" class="win" @onClose="onClose" @unplace="unplaceUnit()" :actions="[
				{
					name: 'onClose',
					icon: 'close'
				},
				{
					name: 'unplace',
					icon: 'arrow_up'
				}
			]" :columns="[
				{
					label: openUnit ? openUnit.full_name : '',
					name: 'name',
					template: {
						name: 'profile',
						params: {
							photo: {
								data: '/images/icon-boxes.jpg'
							},
							name: {
								name: 'name'
							},
							title: {
								name: 'remarks'
							}
						}
					}
				}
			]" :items="openUnit ? openUnit._embedded.storage : []" @itemClick="deleteStorage" />
			<storage-map-view @newspot="newspot" @copyspot="copyspot" :edit="edit" class="map" :location="filter" @onUnitClick="onUnitClick" @onSpotClick="onSpotClick" :openSpot="openSpot" :openUnit="openUnit" @spotDrop="spotDrop" @unitDrop="unitDrop" @update="update" />
			<new-table-view draggable="unit" class="list" :columns="[
				{
					label: 'Ude af huset',
					name: 'name',
					template: {
						name: 'profile',
						params: {
							photo: {
								data: '/images/icon-crate.jpg'
							},
							name: {
								name: 'full_name'
							},
							title: {
								name: 'remarks'
							}
						}
					}
				}
			]" :items="_unplaced_units" @itemClick="onUnitClick" />
		</div>
	</page-content-layout>
</template>

<script>
	import LeadModel from '../model/Lead'
	import EmailWindow from '../windows/EmailWindow'
	import LeadWindow from '../windows/LeadWindow'
	import QuoteModel from '../model/Quote'
	import QuoteWindow from '../windows/QuoteWindow'
	import OrderModel from '../model/Order'
	import OrderWindow from '../windows/OrderWindow'
	import NewTableView from '../views/NewTableView'
	import merge from '../functions/merge'
	import ContextPopupView from '../views/ContextPopupView'
	import DatePickerStdView from '../views/DatePickerStdView'
	import StorageMapView from '../views/StorageMapView'

	import { bus } from '../../bus'

    export default {
		components: {
			NewTableView,
			DatePickerStdView,
			StorageMapView
		},
		data() {
			return {
				edit: false,
				search: '',

				items: [],
				colors: [],
				status: [],
				date: (new Date()).format('Y-m-d'),
				monthStatus: {},
				ownership: 'all',


				filter: null,

				types: [],

				tasks: [],
				locations: [],
				units: [],


				openUnit: null,
				openSpot: null
			};
		},
		computed: {
			_tasks() {
				return this.tasks.filter((item) => {
					return item.type == 'handling' || (item.details.route && item.details.route.filter((stop) => {
						return stop.instructions && (stop.instructions.hasOwnProperty('store') || stop.instructions.hasOwnProperty('extract'));
					}).length > 0);
				});
			},
			_types() {
				var r = {};

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i];
				}

				

				return r;
			},
			_filter() {
				return this.locations.map((item) => {
					return {
						label: item.name,
						value: item
					};
				});
			},
			_monthStatus() {
				var r = [];

				var src = this.ownership == 'mine' ? this.monthStatus.mine : this.monthStatus.all;

				

				for (var date in src) {
					var s = src[date];

					r.push({
						date: date,
						color: s.red > 0 ? 'red' : (s.yellow > 0 ? 'yellow' : 'green'),
						label: ''
					});
				}

				

				return r;
			},
			_status() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this.status[i].label;
				}

				return r;
			},
			_statusColors() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this.status[i].color;
				}

				return r;
			},
			_statusDesc() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this.status[i].desc;
				}

				return r;
			},
			_colors() {
				var r = [];

				for (var i = 0; i < this.colors.length; ++i) {
					r[this.colors[i].name] = this.colors[i].color;
				}

				return r;
			},

			_unplaced_units() {
				return this.units.filter((item) => {
					return item.spot_id === null;
				});
			}
		},
		watch: {
			date(n, o) {
				this.update();
			},
			locations() {
				
			}
		},
		methods: {
			async editClick() {
				
				
				if (this.edit) await this.axios.put(`/warehouse/locations/${this.filter.id}/`, this.filter);
				this.edit = !this.edit;
			},


			onSpotClick(spot) {
				

				this.openUnit = null;
				this.openSpot = spot;
			},
			onUnitClick(unit) {
				

				this.openSpot = null;
				this.openUnit = unit;
			},
			onClose() {
				
				this.openSpot = null;
				this.openUnit = null;
			},


			


			async newspot(p) {
				

				await this.axios.post('/warehouse/spots/', {
					location_id: this.filter.id,
					x: Math.round(p.x),
					y: Math.round(p.y)
				});

				this.update();
			},

			async copyspot(p, sp) {
				

				var spot = { ...sp };

				spot.location_id = this.filter.id,
				spot.x = Math.round(p.x);
				spot.y = Math.round(p.y);
				delete spot.id;

				await this.axios.post('/warehouse/spots/', spot);

				this.update();
			},


			async deleteStorage(storage) {
				

				if (confirm('Er du sikkert på at du vil slette opbevaringen?')) {
					await this.axios.delete('/warehouse/storage/' + storage.id + '/');
					this.update();
				}
			},

			async unplaceUnit() {
				

				const rem = prompt('Bemærkning');

				await this.axios.put('/warehouse/units/' + this.openUnit.id + '/spot/', {
					spot_id: null,
					remarks: rem
				});

				this.openUnit = null;

				this.update();
			},


			async unitDrop(unit, type, data) {
				

				if (type == 'store') {
					//
					await this.axios.post('/warehouse/storage/', {
						contact_id: data.task.contact_id,
						remarks: data.store,
						unit_id: unit.id
					});
				}

				if (type == 'storage') {
					await this.axios.put('/warehouse/storage/' + data.id + '/unit/', {
						unit_id: unit.id
					});
				}

				this.update();
			},

			async spotDrop(spot, type, data) {
				

				if (type == 'store') {
					//
					await this.axios.post('/warehouse/storage/', {
						contact_id: data.task.contact_id,
						remarks: data.store,
						spot_id: spot.id
					});
				}

				if (type == 'storage') {
					await this.axios.put('/warehouse/storage/' + data.id + '/spot/', {
						spot_id: spot.id
					});
				}

				if (type == 'unit') {
					await this.axios.put('/warehouse/units/' + data.id + '/spot/', {
						spot_id: spot.id
					});
				}

				this.update();
			},



			getInstruction(task, type) {
				if (!task.details.route) return [];

				return task.details.route.reduce((acc, stop) => {
					if (!stop.instructions) return acc;

					for (var key in stop.instructions) {
						if (key == type) {
							acc.push({
								address: `${stop.address}`,
								desc: stop.instructions[key]
							});
						}
					}

					return acc;
				}, []);
			},
			getExtract(task) {

			},
			getInfo(task) {
				if (this.info == 'zip') {
					return this.zipCodes(task.route[0]);
				}

				if (this.info == 'arrival') {
					return this.$options.filters.timestamp(task.from.time);
				}

				if (this.info == 'volume') {
					return task.secondary;
				}
			},

		
			async updateMonthStatus(year, month) {
				//this.monthStatus = (await this.axios.get('/sales/quotes/status/' + year + '/' + month + '/')).data;
			},
			updateTasks(year, month, day) {
				var self = this;

				

				// Status
				this.axios
					.get('/planning/tasks/' + year + '/' + month + '/' + day + '/')
					.then(function (r) {
						
						self.tasks = r.data;

						// Update counters
						//self.booking.employees.booked = 0;
						//self.booking.employees.needed = 0;

						/*for (var i = 0; i < self.tasks.length; ++i) {
							for (var j in self.tasks[i].status.bookings) {
								self.booking.employees.booked += self.tasks[i].status.bookings[j].employees.length;
							}

							self.booking.employees.needed += self.tasks[i].status.totals.employees;
						}*/
					});

				

				//this.updateDateStatus();
			},
			async update() {
				this.axios.put('/activity/warehouse/');
				/*self.items = null;

				var d = new Date(this.date);
				this.items = (await this.axios.get('/sales/quotes/' + d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate() + '/')).data._items;*/

				const self = this;

				[this.locations, this.units] = (await Promise.all([
					this.axios.get('/warehouse/locations/'),
					this.axios.get('/warehouse/units/')
				])).map((res) => {
					return res.data._items;
				});

				if (this.filter === null && this.locations.length > 0) {
					this.filter = this.locations[0];
				} else if (this.locations.length > 0) {
					for (var i = 0; i < this.locations.length; ++i) {
						if (this.locations[i].id == this.filter.id) {
							this.filter = this.locations[i];
						}
					}
				}
				
				if (this.openUnit !== null) {

					this.openUnit = null;//await this.axios.get('/warehouse/units/' + this.openUnit.id + '/');
				}

				if (this.openSpot !== null) {
					this.openSpot = null;// await this.axios.get('/warehouse/spots/' + this.openSpot.id + '/');
				}

				this.updateTasks((new Date(this.date)).getFullYear(), (new Date(this.date)).getMonth() + 1, (new Date(this.date)).getDate());

				this.updateMonthStatus((new Date(this.date)).getFullYear(), (new Date(this.date)).getMonth() + 1);
			}
		},
		mounted() {
			this.update();

			var self = this;

			this.axios
				.get('/sales/quotes/status/')
				.then(function (r) {
					self.status = r.data._items;
				});

			this.axios
				.get('/tasks/types/')
				.then(function (r) {
					self.types = r.data._items;
				});

			this.axios
				.get('/config/status/colors/')
				.then(function (r) {
					self.colors = r.data._items;
				});

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.layout {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr 320px;
		grid-template-rows: auto 1fr;

		& > .new-table-view {
			width: 100%;
			height: 100%;
		}

		

		& > .tasks {
			padding: 20px;

			& > * > .task {
				box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

				background-color: white;
				overflow: hidden;
				margin-bottom: 20px;
				border-radius: 5px;
				display: grid;
				grid-template-columns: [left] 5px [after-color] 135px [after-zip] 100px [after-info] 40px [right];
				grid-template-rows: [top] auto [after-name] auto [after-zip] auto [bottom];

				&:last-child {
					margin-bottom: 0;
				}

				& > .color {
					grid-column: left / after-color;
					grid-row: top / bottom;
				}

				& > .name {
					grid-column: after-color / after-info;
					grid-row: top / after-name;
					padding: 5px;
					font-weight: bold;

					& > span {
						background-color: #f7223f;
						color: white;
						font-size: 12px;
						margin: 5px 5px 0 0;
						padding: 3px 5px 3px 5px;
						font-weight: normal;
					}
				}

				& > .zip {
					grid-column: after-color / after-info;
					grid-row: after-name / after-zip;
					padding: 0 5px 5px 5px;
				}

				& > .inst {
					grid-column: after-color / right;
					grid-row: after-name / bottom;
					

					& > div {
						padding: 5px;
						border-top: 1px solid #F0F0F0;
						cursor: grab;

						& > .address {
							font-size: 14px;
						}

						& > .content {
							padding-top: 10px;
						}
					}
				}

				& > .secondary {
					grid-column: after-zip / right;
					grid-row: after-name / after-zip;
					padding: 0 5px 5px 5px;
					text-align: right;
				}

				& > .arrow {
					grid-column: after-info / right;
					grid-row: top / after-zip;

				}

				& > .teams {
					grid-column: after-color / right;
					grid-row: after-zip / bottom;

					& > .team {
						border-top: 1px solid #f0f0f0;
						padding: 5px;

						& > .header {
							padding: 5px;
							border-radius: 3px;
							cursor: grab;
							color: white;

							& > .title {
								font-weight: bold;
							}

							& > .desc {
								width: 100%;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								margin-top: 5px;
								font-style: italic;
							}
						}

						& > .reqs {
							& > .row {
								display: grid;
								grid-template-columns: 215px 50px;
								margin-top: 5px;

								& > .title, & > .state {
									font-size: 14px;
								}

								& > .title {
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: nowrap;
								}

								& > .state {
									text-align: right;
								}

								&.header {
									margin-top: 10px;

									&::first-child {
										margin-top: 0px;
									}

									& > .title, & > .state {
										font-size: 16px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	.date {
		grid-column: 1;
		grid-row: 1 / 2;
		background-color: #f0f0f0;
		padding: 30px;

		border-bottom: 1px solid #cecece;
	}

	.tasks {
		grid-column: 1;
		grid-row: 2 / 3;
		background-color: #f0f0f0;		
	}

	.win {
		grid-column: 1 / 2;
		grid-row: 1 / 3;
		border-left: 1px solid #cecece;
		background-color: white;
	}

	.map {
		grid-column: 2 / 3;
		grid-row: 1 / 3;
		border-left: 1px solid #cecece;
	}

	.list {
		grid-column: 3 / 4;
		grid-row: 1 / 3;
		border-left: 1px solid #cecece;
	}
</style>